export default "__VITE_ASSET__DZ04dzk5__"